import { all} from 'redux-saga/effects';
import { authStateChangeWatcher} from './authStateChange.saga'
import { registerWatcher } from './register.saga';
import { registerGoogleWatcher } from './register_google.saga'
import { registerFacebookWatcher } from './register_facebook.saga'
import { logoutWatcher} from './logout.saga';
export default function* authSaga() {
    yield all([
        authStateChangeWatcher(),
        registerWatcher(),
        registerGoogleWatcher(),
        registerFacebookWatcher(),
        logoutWatcher(),
    ]);
}